import { createSelector } from 'reselect';
import { RootState } from '../../store/store';

// Базовые селекторы
const isLoadingSelector = (state: RootState) => state.balance.isLoading;
const errorsSelector = (state: RootState) => state.balance.errors;
const balanceSelector = (state: RootState) => state.balance.balance;

// Селекторы состояния загрузки
export const selectIsLoadingList = createSelector(isLoadingSelector, isLoading => isLoading.list);

export const selectIsLoadingCreateBalance = createSelector(
  isLoadingSelector,
  isLoading => isLoading.createBalance,
);

export const selectIsLoadingCreateOperation = createSelector(
  isLoadingSelector,
  isLoading => isLoading.createOperation,
);

// Селекторы состояния ошибок
export const selectListError = createSelector(errorsSelector, errors => errors.list || '');

export const selectCreateBalanceError = createSelector(
  errorsSelector,
  errors => errors.createBalance || '',
);

export const selectCreateOperationError = createSelector(
  errorsSelector,
  errors => errors.createOperation || '',
);

// Селекторы данных баланса
export const selectBalance = createSelector(balanceSelector, balance => balance);

// Селектор общей суммы баланса (если `total` строка и нужно её конвертировать)
export const selectBalanceTotal = createSelector(balanceSelector, balance =>
  balance ? parseFloat(balance.total) : 0,
);

// Селектор для получения активных операций
export const selectActiveOperations = createSelector(balanceSelector, balance =>
  balance ? balance.operations.filter(op => op.is_active) : [],
);

// Селекторы операций по направлениям: доход (0) и расход (1)
export const selectIncomeOperations = createSelector(balanceSelector, balance =>
  balance ? balance.operations.filter(op => op.direction === 0) : [],
);

export const selectExpenseOperations = createSelector(balanceSelector, balance =>
  balance ? balance.operations.filter(op => op.direction === 1) : [],
);

// Селектор для фильтрации операций по минимальной сумме
export const selectOperationsByMinAmount = (minAmount: number) =>
  createSelector(balanceSelector, balance =>
    balance ? balance.operations.filter(op => parseFloat(op.amount) >= minAmount) : [],
  );
